export const SIDEBAR_WIDTH = 'calc(6 / 7 * 100vw)';
export const SIDEBAR_MAX_WIDTH = '330px';
